export default __webpack_public_path__ + "static/media/dr-image.6c96ea35.png";